import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewExSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M12.284 12.31H5.625V5.63h6.66zm0 10.02H5.625v-6.68h6.66zm0 10.02H5.625v-6.68h6.66zm10.031-20.04h-6.66V5.63h6.66zm0 10.02h-6.66v-6.68h6.66zm0 10.02h-6.66v-6.68h6.66zm3.37-26.72h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zM35.716 5.63h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm0 10.02h6.659v6.68h-6.659zm-23.432 16.7H5.625v-6.68h6.66zm10.031 0h-6.66v-6.68h6.66zm10.03 0h-6.659v-6.68h6.66zm3.371-6.68h6.659v6.68h-6.659z" }) }) })
});
export default SvgViewExSmall;
